<template>
  <ValidationProvider ref="textProvider" :name="$attrs['name'] || 'text'" rules="required" v-slot="{ errors }">
    <label class="pb-2">{{ label }}</label>
    <v-text-field solo type="text" :maxlength="length" v-bind="$attrs" @input="onInput($event)" :placeholder="placeholder"
      :error-messages="errors">
    </v-text-field>
  </ValidationProvider>
</template>

<script lang="ts">
import {
  Component, Vue, Prop,
} from 'vue-property-decorator';

@Component
export default class TextComponent extends Vue {
  @Prop({ default: '' }) inputValue!: string;
  @Prop({ default: 50 }) length!: number;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: 'الرجاء ملء الحقل' }) placeholder!: string;
  @Prop({ default: '' }) label!: string;

  async onInput(value: string): Promise<void> {
    const result = await (this.$refs.textProvider as any).validate(value);
    this.$emit('update:inputValue', value);

    if (this.index !== -1) {
      this.$emit('controlDataChanged', { value, index: this.index, isValid: result.valid });
    }
  }
}
</script>
